{
  "translation": {
    "select": "Pasirinkti",
    "landing": {
      "hero": {
        "title": "Registruokitės mūsų paslaugoms internetu",
        "notification": "Pacientų lojalumo programos nuolaidos taikomos tik prisijungus prie paskyros",
        "description": "Įveskite norimos paslaugos pavadinimą ar specialisto vardą ir registruokitės nuotolinei konsultacijai arba vizitui diagnostikos centre/klinikoje:",
        "inputText": "Ieškoti paslaugos ar specialisto",
        "buttonSpacer": "Arba",
        "buttonText": "Rinktis paslaugą"
      },
      "heroError": {
        "title": "Įvyko klaida",
        "description": "Atsiprašome, įvyko serverio klaida. Bandykite vėliau."
      },
      "categories": {
        "title": "Pasirinkite paslaugą:"
      },
      "benefits": {
        "title": "Lengva ir greita registracija",
        "text": "Kelių mygtukų paspaudimais užsiregistruokite kontaktinėms ar nuotolinėms konsultacijoms, tyrimams ir kitoms paslaugoms",
        "buttonText": "Rinktis paslaugą",
        "benefit1": "Rinkitės iš gausaus procedūrų ir patyrusių specialistų sąrašo",
        "benefit2": "Išsirinkite jums tinkamiausią vizito ar konsultacijos laiką",
        "benefit3": "Paprastai apmokėkite ir laukite procedūros arba vizito"
      }
    },
    "header": {
      "aboutLabel": "<a>Apie</a>",
      "servicesLabel": "<a>Paslaugos</a>",
      "findUsLabel": "<a>Raskite mus</a>",
      "ourDoctorsLabel": "<a>Mūsų gydytojai</a>",
      "pricesLabel": "<a>Kainynai</a>",
      "becomePatientLabel": "Tapk pacientu",
      "registration": "Registracija",
      "selfService": {
        "login": "Prisijungti",
        "account": "Paskyra",
        "logout": "Atsijungti"
      }
    },
    "footer": {
      "cookiePolicyLabel": "<a>Slapukų pranešimas</a>",
      "privacyPolicyLabel": "<a>Privatumo politika</a>",
      "termsOfUseLabel": "<a>Naudojimosi sąlygos</a>",
      "copyrightLabel": "Autorinės teisės 2023"
    },
    "filters": {
      "clear": "Išvalyti filtrą",
      "specialty": {
        "label": "Specializacija",
        "emptyValue": "Visos specializacijos"
      },
      "specialist": {
        "label": "Specialistas",
        "emptyValue": "Visi specialistai"
      },
      "city": {
        "label": "Miestas",
        "emptyValue": "Visi miestai"
      },
      "service": {
        "label": "Paslauga",
        "emptyValue": "Visos paslaugos"
      },
      "visitPaymentType": {
        "label": "Mokėjimas",
        "emptyValue": "Visi mokėjimo būdai"
      },
      "department": {
        "label": "Padalinys",
        "emptyValue": "Padalinys"
      }
    },
    "timeSession": {
      "stickyMessage": "Užsakymui pateikti liko:",
      "warningModal": {
        "title": "Už <strong>{{time}} min</strong> baigsis paslaugos rezervacijos laikas",
        "description": "Nepratęsus rezervacijos laiko, paslauga bus automatiškai pašalinta ir pasirinktas laikas bus atlaisvintas kitiems.",
        "cancelButton": "Nutraukti rezervaciją",
        "extendButton": "Pratęsti laiką"
      },
      "expiredModal": {
        "title": "Apgailestaujame, tačiau pasibaigė paslaugos rezervacijai skirtas laikas.",
        "description": "Norėdami užsisakyti paslaugą, atlikite rezervaciją iš naujo.",
        "closeButton": "Uždaryti"
      }
    },
    "registration": {
      "tlkTooltip": "Iš PSDF biudžeto kompensuojamos paslaugos teikiamos pacientams nemokamai tik tuo atveju, jeigu pacientas pateikia gydytojo išduotą siuntimą ir yra visos teisės aktuose nurodytos prielaidos (sąlygos), kurioms esant atitinkamos paslaugos gali būti teikiamos pacientams nemokamai. Daugiau informacijos: <a>čia</a>",
      "3TTooltip": "Iš PSDF biudžeto kompensuojamos paslaugos teikiamos pacientams tik tuo atveju, jeigu pacientas pateikia gydytojo išduotą siuntimą ir yra visos teisės aktuose nurodytos prielaidos (sąlygos), kurioms esant atitinkamos paslaugos gali būti teikiamos pacientams PSDF finansuojama tvarka. Daugiau informacijos: <a>čia</a>",
      "sgTlkTooltip": "Iš PSDF biudžeto kompensuojamos paslaugos teikiamos pacientams nemokamai tik tuo atveju, jeigu pacientas yra prisirašęs prie gydymo įstaigos ir yra visos teisės aktuose nurodytos prielaidos (sąlygos), kurioms esant atitinkamos paslaugos gali būti teikiamos pacientams nemokamai. Daugiau informacijos: <a>čia</a>",
      "consultationType": {
        "tabName": "Pasirinkite konsultacijos tipą",
        "title": "Konsultacijos tipas",
        "primaryVisit": "Registruojuosi pirminei konsultacijai <small> Pirminės konsultacijos kaina {{price}}</small>",
        "secondaryVisit": "Registruojuosi pakartotinei konsultacijai dėl tos pačios priežasties 1 mėn. laikotarpyje <small>Antrinės konsultacijos kaina {{price}}</small>"
      },
      "time": {
        "tabName": "Pasirinkite laiką"
      },
      "expressCare": {
        "tabName": "Pasirinkite dėl kokių nusiskundimų registruojatės"
      },
      "form": {
        "tabName": "Užpildykite formą",
        "fieldPurposeLabel": "Konsultacijos tikslas, jaučiami negalavimai, kitos pastabos",
        "fielfPurposeLabelForContraindications": "Išsami informacija apie pažymėtas kontraindikacijas arba kitos reikšmingos pastabos (nusiskundimai, tyrimo tikslas ir kt.)",
        "formTitle": "Apgailestaujame, tačiau nematome Jūsų prie klinikos prisirašiusių pacientų sąrašuose. Prašome prisirašyti prie klinikos ir tik tuomet pildyti užklausos formą. Patogiai prisirašyti prie klinikos galite čia: <a href=\"https://mano.affidea.lt/transfer-request\">Tapk Pacientu</a>. Dėkojame, Affidea",
        "dropDownTitle": "Kreipimosi tema",
        "fieldFileLabel": "Prisekite siuntimą, anksčiau atliktų tyrimų rezultatus ar kitą reikalingą informaciją (PNG, JPEG, PDF):",
        "fieldChildCheckbox": "Registruoju vaiką iki 18 metų",
        "fieldChildAgeFromCheckbox": "Registruoju vaiką nuo {{ageFrom}} metų",
        "fieldChildAgeFromToCheckbox": "Registruoju vaiką nuo {{ageFrom}} iki {{ageTo}} metų",
        "fieldNameLabel": "Vardas",
        "fieldSurnameLabel": "Pavardė",
        "fieldBirthDateLabel": "Gimimo data",
        "fieldTermsAndConditions": "Susipažinau ir sutinku su <a>duomenų tvarkymo taisyklėmis.</a>"
      },
      "questions": {
        "tabName": "Pažymėkite atsakymus",
        "fieldServiceQuestionLabel": "Prašome pažymėti, kodėl norite paslaugoms registruotis mokama tvarka:",
        "fieldContraindicationQuestionLabel": "PAŽYMĖKITE, jei turite bent vieną iš šių kontraindikacijų:",
        "contraindicationQuestion" : "Pasirinkite kontraindikacijas"
      }
    },
    "cart": {
      "title": "Pasirinktos paslaugos",
      "tab1Name": "Įveskite reikiamus duomenis",
      "tab2Name": "Apmokėkite užsakymą",
      "tab2Psdf": "Patvirtinkite užsakymą",
      "fieldNameLabel": "Vardas",
      "fieldSurnameLabel": "Pavardė",
      "fieldCodeLabel": "Asmens kodas",
      "fieldPhoneLabel": "Telefono numeris",
      "fielEmailLabel": "El. pašto adresas",
      "agreementGroulLabel": "Sutikimas su taisyklėmis",
      "contactGroupLabel": "Kontaktiniai duomenys užsakymo patvirtinimui",
      "personalGroupLabel": "Jūsų asmeniniai duomenys",
      "patientGroupLabel": "Paciento duomenys",
      "buyerGroupLabel": "Mokėtojo duomenys",
      "fieldAgreement1Label": "Susipažinau ir sutinku su <a>paslaugų teikimo nuotoliniu būdu taisyklėmis</a>",
      "fieldAgreement2Label": "Susipažinau ir sutinku su <a>duomenų tvarkymo taisyklėmis.</a>",
      "fieldAgreement3Label": "Susipažinau ir sutinku su <a>išankstinės registracijos ir pacientų portalo naudojimosi taisyklėmis.</a>",
      "couponCheckbox": "Panaudoti dovanų kuponą",
      "discountCodeCheckbox": "Panaudoti nuolaidos kodą",
      "fieldCouponLabel": "Įveskite dovanų kupono numerį",
      "fieldDiscountCodeLabel": "Įveskite nuolaidos kodą",
      "fieldAgreement4Label": "Sutinku sumokėti visą užregistruotų paslaugų kainą, jeigu registracijos laiku neatvyksiu į įstaigą gauti paslaugų ir/ar neinformuosiu įstaigos apie neatvykimą bent prieš 24 val. iki numatyto paslaugų teikimo"
    },
    "patientInfo": {
      "specialistLabel": "Gydytojo vardas ir pavardė",
      "healthCenterSpecialistLabel": "Gyd. psichiatro vardas ir pavardė",
      "specialistEmpty": "Įveskite gydytojo vardą ir pavardę",
      "healthCenterSpecialistEmpty": "Įveskite gyd. psichiatro vardą ir pavardę"
    },
    "coupons": {
      "fieldAgreement3Label": "Susipažinau ir sutinku su <a>dovanų kupono įsigijimo ir naudojimo taisyklėmis</a>",
      "fieldAgreementComplexLabel": "Susipažinau ir sutinku su <a>abonementų naudojimo taisyklėmis</a>",
      "couponExpired": "Dovanų kuponas nebegalioja",
      "couponSingleUsed": "Dovanų kuponas panaudotas",
      "couponNotFound": "Nerastas kuponas su tokiu numeriu",
      "overPrice": "Pridėtų dovanų kuponų vertė jau viršija paslaugos sumą",
      "discountCodeNotFound": "Nuolaidos kodas nerastas",
      "couponEmpty": "Neįvestas kupono numeris",
      "couponCancelled": "Dovanų kuponas anuliuotas",
      "couponNonApplicable": "Dovanų kuponas netinkamas",
      "couponReserved": "Dovanų kuponas rezervuotas",
      "couponOther": "Dovanų kupono panaudojimas negalimas",
      "couponUsed": "Toks dovanų kuponas jau įvestas",
      "couponOtherService": "Dovanų kupono panaudojimas negalimas dėl paslaugų ribojimo",
      "couponBalanceEmpty": "Dovanų kuponas išnaudotas",
      "couponCompany": "Galimas tik Affidea dovanų kupono panaudojimas"
    },
    "validation": {
      "referralToDoctor": "Tyrimo atlikimui būtina turėti šeimos gydytojo ar gydytojo specialisto siuntimą. Prisekite siuntimą.",
      "referralToRegistration": "Registracijai būtina turėti šeimos gydytojo ar gydytojo specialisto siuntimą. Prisekite siuntimą.",
      "referralToDoctorNotFamily": "Tyrimo atlikimui būtina turėti gydytojo specialisto siuntimą. Prisekite siuntimą.",
      "requiredField": "Laukelis privalomas",
      "patientCommentTooLong": "Galima įvesti ne daugiau kaip {{count}} simbolių.",
      "invalidFormat": "Netinkamas formatas",
      "calendarNoAvailableTime": "Šiuo metu visi vizitų laikai yra rezervuoti. Dėkojame už kantrybę ir prašome pabandyti vėliau",
      "contraindicationQuestion": "Dėl nurodytos kontraindikacijos internetinė registracija negalima. Prašome registruotis tel. {{shortPhoneNumber}} arba {{email}}",
      "contraindicationPregnancyAndBirthControlQuestion": "Informacijos lange nurodykite spiralės pavadinimą. Jeigu esate nėščia, prašome tyrimui registruotis tel. {{shortPhoneNumber}} arba {{email}}",
      "additioanlContraindicationQuestion": "Dėl nurodytos kontraindikacijos paslauga negali būti teikiama. Rekomenduojame registruotis gydytojo dermatovenerologo konsultacijai <a>internetu</a>, tel. {{shortPhoneNumber}} arba {{email}}",
      "passwordStrongSymbols": "Slaptažodis turi būti bent 8 simbolių, sudarytas iš mažųjų ir bent vienos didžiosios raidžių, bent vieno skaitmens ir vieno iš šių simbolių <strong>@$!%*#?&^`~+-</strong>",
      "password": "Slaptažodis turi būti bent 8 simbolių, sudarytas iš mažųjų ir bent vienos didžiosios raidžių, bent vieno skaitmens ir vieno iš šių simbolių @$!%*#?&^`~+-",
      "personalCode": "Klaidingas asmens kodas",
      "smartId": "Klaidingas asmens kodas",
      "personalCodeNumbers": "Asmens kodas turi būti sudarytas tik iš skaičių",
      "number": "Netinkamas telefono formatas, turi būti +3706*******",
      "dataAgreement": "Jūs nepatvirtinote, kad susipažinote ir sutikote su duomenų tvarkymo taisyklėmis",
      "patientTosAgreement": "Jūs nepatvirtinote, kad susipažinote ir sutikote su pacientų portalo naudojimosi taisyklėmis",
      "notMatchingPassword": "Slaptažodžiai turi sutapti",
      "notMatchingEmail": "El. pašto adresai turi sutapti",
      "latinOnlyEmail": "Galima naudoti tik lotyniškas raides",
      "invalidEmailPhone": "Įveskite teisingą telefono numerį (+3706*******) arba el.pašto adresą",
      "invalidPhone": "Įveskite teisingą telefono numerį (+3706*******)",
      "invalidEmail": "Netinkamas el. pašto formatas",
      "checkEmail": "Patikrinkite ar teisingai įvedėte el.pašto adresą",
      "smsFormat": "Netinkamai įvestas sms kodas",
      "smsCodeLength": "Kodas turi būti sudarytas iš 4 skaitmenų",
      "phoneNotConfirmed": "Telefono numeris nėra patvirtintas",
      "blockedAccount": "Jūsų paskyra šiuo metu yra užblokuota. Norint paskyrą atkurti, prašome atvykti į bet kurį Affidea medicinos centrą ir nepamirškite su savimi turėti asmens dokumento",
      "takenEmail": "El. pašto adresas užimtas",
      "takenEmailV2": "El. pašto adresas užimtas kitoje paskyroje",
      "emailMatch": "Įveskite naują el.paštą",
      "phoneMatch": "Įveskite naują telefono nr.",
      "emptyList": "Sąrašas tuščias",
      "invalidUrl": "Nuoroda turi prasidėti https//...",
      "successfullySaved": "Duomenys sėkmingai išsaugoti",
      "noPicture": "Įkelkite nuotrauką prieš išsaugodami duomenis"
    },
    "common": {
      "workplace": "Diagnostikos centras/klinika",
      "remoteService": "Nuotolinės konsultacijos",
      "price": "Kaina",
      "priceDetails": "Paslaugai suteikti gali būti reikalingos papildomos paslaugos. Visos kainos <a href=\"https://affidea.lt/lt/kainos/\" target=\"_blank\">čia</a>.",
      "multipleServicesInfo" : "Norėdami vieno apsilankymo metu atlikti daugiau nei vieną laboratorinį tyrimą, išsirinkę vizito laiką, sekančiame žingsnyje spauskite \"Pasirinkti papildomus laboratorinius tyrimus\"",
      "laboratoryVisits": "Į laboratorinio tyrimo kainą Kraujo ir COVID tyrimo ėmimo paslaugos nėra įskaičiuotos, jos turi būti apmokamos papildomai",
      "availableLanguages": "Galimos konsultacijos kalbos",
      "registerToVisit": "Registruokitės vizitui",
      "nearestRegistration": "Nuo",
      "noFreeVisits": "Nėra laisvų vizitų",
      "cancel": "Atšaukti",
      "save": "Išsaugoti",
      "extra": "Papildomos gydytojo teikiamos paslaugos",
      "valid": "Galioja iki: "
    },
    "cookies": {
      "title": "Slapukų nustatymai",
      "allowAll": "Sutikti su visais",
      "settings": "Slapukų nustatymas",
      "description": "Siekdami suteikti Jums geresnę naršymo patirtį, šioje svetainėje naudojame <strong>slapukus (angl. cookies)</strong>. <a>Sužinokite daugiau, kaip naudojami slapukai ir kaip galite pakeisti savo interneto naršyklės nustatymus.</a>",
      "mandatory": {
        "title": "Privalomi slapukai",
        "description": "Būtini norint užtikrinti svetainės ir elektroninių paslaugų veikimą. Šiems slapukams nereikia jūsų sutikimo ir jie veikia visada."
      },
      "functional": {
        "title": "Veikimo ir funkcionalumo slapukai",
        "description": "Šie slapukai naudojami mūsų svetainės veikimui ir funkcionalumui pagerinti, tačiau nėra būtini norint naudotis mūsų internetine svetaine. Tuo pačiu informuojame, kad be šių slapukų gali neveikti kai kurios mūsų svetainės funkcijos."
      },
      "marketing": {
        "title": "Reklaminiai slapukai",
        "description": "Šie slapukai naudojami mūsų reklaminių pranešimų optimizavimui. Šių slapukų dėka reklaminiai pranešimai tinkamai parenkami ir nėra dubliuojami ar rodomi keletą kartų iš eilės."
      },
      "analysis": {
        "title": "Analizės ir pritaikymo slapukai",
        "description": "Šie slapukai renka informacija, kurios dėka galime geriau suprasti, kaip naudojatės mūsų internete svetaine, kaip efektyviai veikia mūsų rinkodarinės kampanijos bei padėti mums suasmeninti informaciją mūsų internetinėje svetainėje, kad jūsų naršymo patirtis būtų dar geresnė."
      }
    },
    "fileUpload": {
      "too-may-files": "Maksimalus failų kiekis 10, prašome iš naujo perkrauti puslapį",
      "file-too-large": "Failas yra per didelis (maksimalus dydis 10MB)"
    },
    "transfer": {
      "title": "Prašymas leisti gydytis pasirinktoje pirminės ambulatorinės asmens sveikatos priežiūros įstaigoje ar psichikos sveikatos centre",
      "secondaryTitle": "Prašymas leisti gydytis pas kitą pasirinktos PASPĮ gydytoją",
      "success": "Prašymas sėkmingai pateiktas",
      "additionalInfo": "Informuojame, kad prie Jūsų pasirinkto šeimos gydytojo būsite prirašyti per 1 d. d.",
      "centerSpecialistDefault": "Sutinku, kad gyd. psichiatrą man paskirtų pirminės ambulatorinės asmens sveikatos priežiūros įstaigos administracija",
      "specialistDefault": "Sutinku, kad šeimos gydytoją man paskirtų pirminės ambulatorinės asmens sveikatos priežiūros įstaigos administracija",
      "fields": {
        "firstName": "Paciento vardas",
        "lastName": "Paciento pavardė",
        "personalCode": "Asmens kodas",
        "phoneNumber": "Telefono numeris",
        "address": "Adresas (gatvė, namo ir buto nr., miestas, rajonas)",
        "company": "PASPĮ klinika, į kurią pageidaujate būti įrašyta(-s)",
        "center": "Pirminės psichikos sveikatos priežiūros paslaugas teikiančių įstaigų sąrašas",
        "email": "El.pašto adresas (šiuo adresu gausite jūsų užpildytą ir pasirašytą prašymą)",
        "specialist": "Pasirinktas gydytojas",
        "addSpecialist": "Pritaikyti gydytoją",
        "centerSpecialist": "Norėčiau pasirinkti šį gydytoją",
        "agreedWithTermsAndConditions": "Sutinku, kad mano asmeniniai duomenys būtų panaudoti registracijos tikslais",
        "agreedWithTermsAndConditionsList": "Prašau mane įrašyti į pirminės psichikos sveikatos priežiūros paslaugas teikiančios įstaigos aptarnaujamų asmenų sąrašą",
        "informed": "Patvirtinu, kad esu informuotas, jog galiu būti prirašytas prie psichikos sveikatos centro, veikiančio toje savivaldybėje, kurioje paslaugas teikia mano pasirinkta pirminės asmens sveikatos priežiūros įstaiga. Jeigu savivaldybės teritorijoje yra tik vienas psichikos sveikatos centras, galiu būti prirašytas tik prie šio psichikos sveikatos centro. Jeigu savivaldybėje nėra psichikos sveikatos centro, galiu pasirinkti greta esančių savivaldybių, priklausančių tos pačios teritorinės ligonių kasos veiklos zonai, psichikos sveikatos centrus.",
        "send": "Siųsti prašymą",
        "back": "Atgal"
      },
      "backToForm": "Grįžti į formos pildymą",
      "singWithSmartId": "Pasirašyti su Smart-ID",
      "singWithMobileId": "Pasirašyti su M. Parašu",
      "cancelSignIn": "Nutraukti tvirtinimą",
      "smartIdDescription": "Į Jūsų įrenginį išsiųsta tapatybės patvirtinimo užklausa. Jei aukščiau pavaizduotas kodas sutampa su kodu, kurį matote ekrane, patvirtinkite savo tapatybę, įvesdami PIN2 kodą.",
      "controlCode": "Jūsų kontrolinis kodas yra:",
      "smartIdTitle": "Patvirtinkite savo tapatybę:",
      "fileTitle": "Prašome peržiūrėti sugeneruotą prašymą ir pasirašyti:"
    },
    "login": {
      "title": "Pasirinkite prisijungimo būdą",
      "confirmationTitle": "Pasirinkite patvirtinimo būdą",
      "smartId": "Smart-ID",
      "msignature": "M. Parašas",
      "alternative": "ARBA",
      "createAccount": "Sukurkite paskyrą",
      "userpassword": "Prisijungimo vardu ir slaptažodžiu",
      "smartIdTab": {
        "title": "Rinktis kitą prisijungimo būdą",
        "tabName": "Prisijungimas su Smart-ID",
        "placeholder": "Įveskite asmens kodą",
        "country": "Pasirinkite šalį",
        "continue": "TĘSTI"
      },
      "msignatureTab": {
        "title": "Rinktis kitą prisijungimo būdą",
        "tabName": "Prisijungimas su M. Parašu",
        "personalCodePlaceholder": "Įveskite asmens kodą",
        "phoneNumberPlaceholder": "Įveskite telefono numerį (+3706*******)",
        "continue": "TĘSTI"
      },
      "credentialsTab": {
        "title": "Rinktis kitą prisijungimo būdą",
        "tabName": "Prisijungimas slaptažodžiu",
        "emailPlaceholder": "El.pašto adresas",
        "passwordPlaceholder": "Slaptažodis",
        "forgotPassword": "Pamiršote slaptažodį?",
        "badCredentials": "Paskyra su tokiu el. paštu neegzistuoja arba įvestas neteisingas slaptažodis!",
        "submit": "Prisijungti",
        "confirmation": {
          "title": "Patvirtinkite telefono numerį",
          "tabName": "Įveskite kodą gautą SMS žinute",
          "label": "SMS kodas",
          "continue": "TĘSTI"
        },
        "passwordReset": {
          "email": "El. paštas:",
          "phoneNumber": "Telefono numeris",
          "accountNotFound": "Paskyra su tokiu el. paštu arba telefono numeriu neegzistuoja!"
        }
      },
      "tos": {
        "title": "Registracija",
        "tabName": "Naudojimosi savitarnos portalu taisyklės",
        "termsOfUse": "Sutikdami Jūs patvirtinate, kad susipažinote ir sutinkate Savitarnos naudojimosi taisyklėmis ir ",
        "privacyPolicy": "Privatumo politika",
        "agree": "SUTIKTI IR TĘSTI",
        "cancel": "ATŠAUKTI"
      }
    },
    "userRegistration": {
      "initialPage": {
        "title": "Registracija",
        "rules": "Paskyros sukūrimui susipažinkite ir sutikite su duomenų tvarkymo ir portalo naudojimosi taisyklėmis",
        "rulesFromLogin": "Paskyros sukūrimui susipažinkite ir sutikite su duomenų tvarkymo ir portalo naudojimosi taisyklėmis",
        "identityVerificationOption": "Pasirinkite vieną iš asmens tapatybės patikrinimo būdų"
        
      },
      "newAccount": "Dar neturite paskyros? ",
      "registerHere": "Paspauskite žemiau esantį mygtuką",
      "title": "Registracija",
      "register": "REGISTRUOTIS",
      "continue": "TĘSTI",
      "confirmData": "PATVIRTINTI",
      "cancel": "ATŠAUKTI",
      "personalData": {
        "title": "Įveskite paskyros duomenis",
        "personalCode": "Asmens kodas",
        "surname": "Pavardė",
        "password": "Slaptažodis",
        "confirmPassword": "Pakartokite slaptažodį",
        "confirmEmail": "Pakartokite el. pašto adresą"
      },
      "contactData": {
        "title": "Nurodykite kontaktinius duomenis",
        "email": "El. pašto adresas",
        "phone": "Telefono numeris"
      },
      "questions": "Pažymėkite klausimyną (neprivaloma)",
      "agreements": {
        "title": "Pažymėkite sutikimus",
        "firstAgreement": "Susipažinau ir sutinku su ",
        "privacyPolicy": "Privatumo politika",
        "marketingGoals": "Tiesioginės rinkodaros tikslais",
        "secondAgreement": "Sutinku naudoti duomenis ",
        "registerAgeerements": "Susipažinau ir sutinku su ",
        "data": "duomenų tvarkymo taisyklėmis.",
        "tos": "pacientų portalo naudojimosi taisyklėmis"
      },
      "identity": {
        "title": "Pasirinkite asmens tapatybės patikrinimo būdą",
        "smartId": "Smart-ID",
        "msignature": "M. Parašas",
        "footer": "Neturite galimybės patikrinti jūsų asmens tapatybės vienu iš aukščiau pateiktų būdų?",
        "visit": "Atvykite į Affidea padalinį ir mes padėsime jums susikurti paskyrą",
        "smartIdConfirmation": {
          "title": "Rinktis kitą patvirtinimo būdą",
          "tabName": "Patvirtinkite tapatybę su Smart ID"
        },
        "msignConfirmation": {
          "title": "Rinktis kitą patvirtinimo būdą",
          "tabName": "Patvirtinkite tapatybę su M. Parašu"
        }
      }
    },
    "identityConfirm": {
      "title": "Tapatybės patvirtinimas",
      "information": "Į jūsų mobilųjį telefoną išsiųsta identifikacijos užklausa. Įveskite prašomą PIN kodą, kad užbaigti veiksmą.",
      "controlCode": "Kontrolinis kodas",
      "cancel": "Atšaukti",
      "back": "Atgal"
    },
    "userAccount": {
      "sidebar": {
        "myAccountMultiple": "Paskyra",
        "myAccountSingle": "Mano paskyra",
        "accountInfo": "Paskyros informacija",
        "visits": "Vizitų istorija",
        "registrations": "Išankstinės registracijos",
        "logout": "Atsijungti"
      },
      "userInfoTab": {
        "userInfoTitle": "Asmeninė informacija",
        "loginInfoTitle": "Prisijungimo duomenys",
        "accountTitle": "Paskyra",
        "name": "Vardas:",
        "surname": "Pavardė:",
        "birthDate": "Gimimo data:",
        "email": "El. paštas:",
        "deleteEmail": "Atšaukti keitimą",
        "phone": "Telefono Nr.:",
        "discountCardNr": "Nuolaidų kortelės Nr.:",
        "edit": "Redaguoti",
        "changePassword": "Keisti slaptažodį",
        "deleteAccount": "Panaikinti paskyrą",
        "updateData": "Atnaujinti duomenis",
        "deleteConfirm": {
          "confirm": "Ar tikrai norite panaikinti paskyrą? Paskyra bus panaikinta už {{time}} dienų. Tuo laikotarpiu turėsite galimybę paskyros panaikinimą atšaukti",
          "continue": "Panaikinti paskyrą",
          "deleteInfo": "Paskyra bus panaikinta: ",
          "cancelDelete": "Atšaukti panaikinimą",
          "cancel": "Atsisakyti"
        },
        "agreementsTitle": "Sutikimai ir įgalioti asmenys",
        "agreementsManage": "Valdyti"
      },
      "userCredentialsEdit": {
        "newPassword": "Naujas slaptažodis",
        "confirmPassword": "Pakartokite naują slaptažodį",
        "changedPassword": "Paskyros slaptažodis pakeistas sėkmingai"
      },
      "userAccountInfoEdit": {
        "phoneNumber": "Naujas telefono Nr.",
        "email": "Naujas el. pašto adresas"
      },
      "doctorInfo": {
        "newLink": "Gydytojo informacijos nuoroda"
      },
      "serviceInfo": {
        "newLink": "Paslaugos informacijos nuoroda"
      },
      "popupAdministration": {
        "fileUploadLabel": "Įkelti paveikslėlį",
        "deleteFile": "Ištrinti paveikslėlį",
        "showPopup": "Rodyti paveikslėlį pagrindiniame puslapyje"
      },
      "authorizedPersonsEdit": {
        "authorizedPersonsTitle": "Keisti įgaliotus asmenis",
        "authorizedPersons": "Įgalioti asmenys",
        "back": "Atgal",
        "confirmData": "Patvirtinti duomenis"
      },
      "visitHistoryTab": {
        "title": "Vizitų istorija",
        "dateInfo": "Šiame puslapyje pateikta informacija nuo 2021-01-01. Jei Jums reikalingi ankstesni sveikatos įrašai, prašome kreiptis į klinikos registratūrą."
      },
      "registrationsList": {
        "title": "Suplanuotų registracijų sąrašas"
      },
      "visitTab": {
        "visitInfo": "Vizito informacija",
        "service": "Paslauga: ",
        "price": "Kaina:",
        "state": "Būsena:",
        "paymentType": "Mokėjimas:",
        "conclusions": "Išvada:",
        "medicalCenter": "Medicinos centras: ",
        "date": "Vizito data: ",
        "findings": "Vizito išvados",
        "payment": "Apmokėjimas: ",
        "doctor": "Išvadas pateikė gydytojas: ",
        "downloadPDF": "Atsisiųsti PDF išvadų ataskaitą",
        "inquiryPhotos": "Tyrimo nuotraukos",
        "photoStatus": "Nuotraukų būsena: ",
        "viewPhotos": "Peržiūrėti nuotraukas",
        "modal": {
          "price": "Vienkartinė tyrimo nuotraukų atsisiuntimo kaina <strong>{{price}} EUR.</strong>",
          "confirm": "Jeigu sutinkate, paspauskite ''Tęsti'' ir atlikite Apmokėjimą",
          "continue": "TĘSTI",
          "cancel": "Atsisakyti"
        }
      },
      "registrationsTab": {
        "title": "Registracijos informacija",
        "department": "Padalinio pavadinimas: ",
        "departmentAddress": "Padalinio adresas: ",
        "serviceTitle": "Tyrimo ar paslaugos pavadinimas: ",
        "visitDate": "Vizito data",
        "visitReminder": "Prašome atvykti 15min. ankščiau",
        "registrationStatus": "Registracijos būsena: ",
        "servicePreparations": "Pasiruošimas tyrimui: ",
        "reminder": "Priminimas: Nepamirškite asmens dokumento ir siuntimo (jei neturite elektroninės versijos)",
        "payment": "Apmokėjimas: ",
        "doctor": "Paslaugą teikiantis gydytojas: ",
        "siuntimas": "Registracijos siuntimas",
        "cancelRegistrationFailed": "Nepavyko atšaukti registracijos",
        "registrationFailedCancelledSecondary": "Nepavyko atšaukti registracijos",
        "cancelRegistrationSuccess": "Registracija atšaukta sėkmingai",
        "referralData": {
          "institution": "Įstaiga:",
          "date": "Data:",
          "specialist": "Specialistas:"
        }
      }
    },
    "forgotPassword": {
      "title": "Pakeisti slaptažodį",
      "submit": "TĘSTI",
      "form": {
        "password": "Naujas slaptažodis",
        "confirmPassword": "Pakartokite naują slaptažodį",
        "smsCode": "SMS kodas",
        "submit": "PATVIRTINTI"
      }
    },
    "servicePreparations": {
      "title": "Reikalingas pasirengimas tyrimui:"
    }
  }
}
